var _path, _path2, _rect, _circle, _path3, _rect2, _circle2, _rect3, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnv0WorkflowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0f38",
    d: "M14 0c7.74 0 14 6.27 14 14.03C28 21.73 21.71 28 14 28S0 21.72 0 14 6.28 0 14 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.05 8.55h5.26m4.64.27v5.01m0 5.62v-4.93"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2.25,
    x: 13.53,
    y: 7.33,
    fill: "#00edb9",
    rx: 0.36,
    ry: 0.36,
    transform: "rotate(-180 16.85 8.555)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.05,
    cy: 8.55,
    r: 1.35,
    fill: "#00eefe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.05 14.07v5.56m9.9-5.8h-6.53"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2.25,
    x: 7.83,
    y: 12.6,
    fill: "#947eff",
    rx: 0.34,
    ry: 0.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.95,
    cy: 13.83,
    r: 1.35,
    fill: "#7affc3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2.25,
    x: 7.83,
    y: 18.22,
    fill: "#1aaefc",
    rx: 0.34,
    ry: 0.34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.95,
    cy: 19.45,
    r: 1.35,
    fill: "#7affc3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnv0WorkflowIcon);
export default __webpack_public_path__ + "static/media/env0-workflow-icon.d0faeb2f270b4cd36c6713b1ecdc97b1.svg";
export { ForwardRef as ReactComponent };